import React from "react";
import { Link } from 'react-router-dom';
import PropTypes from "prop-types";
import axios from "axios";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Danger from "components/Typography/Danger.jsx";

// @material-ui/icons
import Email from "@material-ui/icons/Email";
// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Footer from "components/Footer/Footer.jsx";
import PreLoginHeader from "components/Header/PreLoginHeader.jsx";

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";

import {getApiHeaders} from "../../assets/helpers/apiHelper";
import { verifyEmail} from "../../assets/helpers/formHelper";
import { API_ROOT, SUPPORT_EMAIL } from 'api-config';

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden",
      email: "",
      responseMessage: "",
      resetButtonDisabled: false
    };

  }


  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleSubmit = event => {
    event.preventDefault();
    if (verifyEmail(this.state.email)) {
      this.setState({
        responseMessage: 'resetting',
        resetButtonDisabled: true
      })

      axios.get(`${API_ROOT}/auth/getNewPassword/?username=` + this.state.email, { headers: getApiHeaders() })
        .then(res => this.handleResetResponse(res.data));
    } else {
      this.setState({ responseMessage: 'Please enter a valid email address.' })
    }
  }
  handleResetResponse(res) {
    if (this._isMounted) {
      var responseMessage
      if (res.message) {
        responseMessage = 'We have sent a new password to ' + this.state.email + ', if that address is associated ' +
          'with an active account. If you don\'t receive the email, please contact support at ' + SUPPORT_EMAIL + '.'
      } else {
        responseMessage = 'There was an error resetting your password. Please contact support at ' + SUPPORT_EMAIL + '.'
      }
      this.setState({
        responseMessage: responseMessage,
        resetButtonDisabled: false
      });
    }
  }

  componentDidMount() {
    this._isMounted = true;
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    this.timeOutFunction = setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
  }
  componentWillUnmount() {
    this._isMounted = false;
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }



  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <PreLoginHeader />
        <GridContainer justifyContent="center">
          <GridItem xs={12} sm={6} md={4}>
            <form onSubmit={this.handleSubmit}>
              <Card login className={classes[this.state.cardAnimaton]}>
                <CardHeader
                  className={`${classes.cardHeader} ${classes.textCenter}`}
                  color="cirrusBlue"
                >
                  <h4 className={classes.cardTitle}>Reset password</h4>
                </CardHeader>
                <CardBody>
                  <CustomInput
                    labelText="my Email..."
                    id="email"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      onChange: this.handleChange,
                      endAdornment: (
                        <InputAdornment position="end">
                          <Email className={classes.inputAdornmentIcon} />
                        </InputAdornment>
                      )
                    }}
                  />
                  <div className={classes.center}>
                    Please enter your email address, and we will send you a new password when you click the "Reset" button.
                  </div>
                  <div className={classes.center}>
                    <Danger><span id="passwordResetStatusMessage">{this.state.responseMessage}</span></Danger>
                  </div>
                </CardBody>
                <div className={classes.justifyContentCenter}>
                  <Button id="passwordResetButton" color="cirrusBlue" simple size="lg" block type="submit" disabled={this.state.resetButtonDisabled}>
                    Reset
                  </Button>
                </div>
                <CardFooter className={classes.justifyContentCenter}>
                  &nbsp;<Link className={classes.linkClass} to="/login">Log in instead.</Link>
                </CardFooter>
                <CardFooter className={classes.justifyContentCenter}>
                  Don't have an account?&nbsp;<Link className={classes.linkClass} to="signup">Sign up here.</Link>
                </CardFooter>
              </Card>
            </form>
          </GridItem>

        </GridContainer>
        <Footer fluid />
      </div>
    );
  }
}

ResetPassword.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(loginPageStyle)(ResetPassword);
